import { motion } from "framer-motion";
import underline from "./assets/underline.png";

const OverviewSection = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="bg-gray-900 text-white font-poppins py-10 px-4 sm:px-8 md:px-16 lg:px-24"
    >
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-6">

        <div className="relative">
          <h2 className="text-3xl sm:text-4xl font-bold uppercase">
            Overview
          </h2>

          <img
            src={underline}
            alt="decorative underline"
            className="absolute left-0 bottom-[-10px] w-24 sm:w-28"
          />
        </div>

        <p className="text-base leading-relaxed max-w-3xl">
          Development builds strategic partnerships, while business development
          drives client acquisition and growth. Software consulting and custom
          development provide expert, adaptive solutions across evolving
          industry needs.
        </p>

      </div>
    </motion.section>
  );
};

export default OverviewSection;